import * as history from 'history';

const historyConfig = {
	basename: 'monasso'
};
export default history.createBrowserHistory();
